<div class="ipm-beat-section ipm-bpm-arena-section"  [class.ipm-type-recommended-beat]="type === 'recommended'" [class.ipm-type-trending-beat]="type === 'trending'" [class.ipm-type-curated-beat]="type === 'curated'">
    <div class="ipm-heading-section  pb-1" [class.ipm-container]="type !== 'ads_beats'"  *ngIf="type !== 'bpmArena'" [class.curated-ipm-container-heading]="type === 'curated'">
        <div class="ipm-heading-container">
            <h2 [innerHTML]="heading" [class.curated-heading]="type === 'curated'"></h2>
            <!-- <ipm-button-toggle [selectedValue]="commonFunction.typeOfList" [textArray]="commonFunction.textArray" (onChangeToggleButtonEvent)="onChangeToggle($event)" *ngIf="type === 'recommended'"></ipm-button-toggle> -->
        </div>
        <ng-container *ngIf="type !== 'ads_beats'">
            <div class="ipm-button" *ngIf="type !== 'curated'">
                <button type="button" class="btn btn-outline-light ipm-see-all-btn" (click)="navigateTo()">See All -></button>
            </div>
            <a *ngIf="type === 'curated'" (click)="navigateTo()" class="view-all-link" role="button" tabindex="0">View All →</a>
        </ng-container>
        <ng-container *ngIf="type === 'ads_beats'">
            <div class="ads-carousel-nav">
                <button class="ads-nav-btn" (click)="prevSlide()">
                    <i class="pi pi-arrow-left"></i>
                </button>
                <button class="ads-nav-btn" (click)="nextSlide()">
                    <i class="pi pi-arrow-right"></i>
                </button>
            </div>
        </ng-container>
    </div>
    <div class="ipm-play-list-section " [class.ipm-container]="type !== 'bpmArena' && type !== 'ads_beats'" [class.curated-ipm-container]="type === 'curated'">
        <owl-carousel-o #owlCar [options]="customOptions" [id]="type+'_slider'" [class.ads-button-section]="type === 'ads_beats'">
            <ng-container *ngIf="type === 'recommended'">
                <ng-container *ngIf="(playListData | filterDataArray : commonFunction.typeOfList : 'category' : this.type).length > 0; else playListLoadingSction">
                      <ng-container *ngFor="let playListItem of  (playListData | filterDataArray : commonFunction.typeOfList : 'category' : this.type)">
                        <ng-template carouselSlide >
                            <figure class="ipm-card-play-list" (click)="gotoRoutePath('/playlist/'+playListItem.urlSlug)">
                                <div class="ipm-track-images">
                                    <img priority priority [src]="playListItem?.thumbnailUrl" class="rounded rounded_img" alt="..." width="225"
                                        height="225">
                                </div>
                                <div class="ipm-pay-music-beat-section grid-view playlist-play-btn" [class.ipm-beat-playing]="isPlaylistPlaying(playListItem)" (click)="playPlaylist(playListItem, $event)">
                                    <div class="icon-section">
                                        <i class="fa fa-play playIcon" *ngIf="!isPlaylistPlaying(playListItem)"></i>
                                        <i class="fas fa-pause playIcon" *ngIf="isPlaylistPlaying(playListItem)"></i>
                                    </div>
                                </div>
                                <figcaption class="ipm-track-details">
                                    <div class="followers">
                                        <p>
                                            <!-- <span *ngIf="playListItem.followers.length > 50" >{{commonFunction.nFormatter(playListItem.followers.length, 1)}} Followers - </span> -->
                                            <span>{{commonFunction.nFormatter(playListItem.beats.length, 1)}} Beats</span>
                                        </p>
                                    </div>
                                    <div class="ipm-popular_music">
                                        <p>{{playListItem?.title}} <span *ngIf="playListItem?.isOfficialPlaylist"></span> </p>
                                        <p>{{playListItem?.authorName}} <span *ngIf="playListItem?.isOfficialPlaylist"><img priority src="./assets/imgs/subs_premium_tick.svg" alt="verify-icon"  width="20" height="20"></span> </p>
                                    </div>
                                </figcaption>
                            </figure>
                        </ng-template>
                    </ng-container>
                </ng-container>
                <ng-template #playListLoadingSction>
                  <ng-container *ngFor="let trendingItem of emptyListArray">
                      <ng-template carouselSlide>
                          <ipm-skeleton-loader></ipm-skeleton-loader>
                      </ng-template>
                    </ng-container>
                  </ng-template>
            </ng-container>
            <!-- Curated Playlists Support -->
            <ng-container *ngIf="type === 'curated'">
                <ng-container *ngIf="playListData && playListData.length > 0; else playListLoadingSctionCurated">
                      <ng-container *ngFor="let playListItem of playListData">
                        <ng-template carouselSlide >
                            <figure class="ipm-card-play-list" (click)="gotoRoutePath('/playlist/'+playListItem.urlSlug)">
                                <div class="ipm-track-images">
                                    <img priority priority [src]="playListItem?.thumbnailUrl" class="rounded rounded_img" alt="..." width="225"
                                        height="225">
                                </div>
                                <div class="ipm-pay-music-beat-section grid-view playlist-play-btn" [class.ipm-beat-playing]="isPlaylistPlaying(playListItem)" (click)="playPlaylist(playListItem, $event)">
                                    <div class="icon-section">
                                        <i class="fa fa-play playIcon" *ngIf="!isPlaylistPlaying(playListItem)"></i>
                                        <i class="fas fa-pause playIcon" *ngIf="isPlaylistPlaying(playListItem)"></i>
                                    </div>
                                </div>
                                <figcaption class="ipm-track-details">
                                    <div class="followers">
                                        <p>
                                            <!-- <span *ngIf="playListItem.followers.length > 50" >{{commonFunction.nFormatter(playListItem.followers.length, 1)}} Followers - </span> -->
                                            <span>{{commonFunction.nFormatter(playListItem.beats.length, 1)}} Beats</span>
                                        </p>
                                    </div>
                                    <div class="ipm-popular_music">
                                        <p>{{playListItem?.title}} <span *ngIf="playListItem?.isOfficialPlaylist"></span> </p>
                                        <p>{{playListItem?.authorName}} <span *ngIf="playListItem?.isOfficialPlaylist"><img priority src="./assets/imgs/verify-icon.webp" alt="verify-icon"  width="20" height="20"></span> </p>
                                    </div>
                                </figcaption>
                            </figure>
                        </ng-template>
                    </ng-container>
                </ng-container>
                <ng-template #playListLoadingSctionCurated>
                  <ng-container *ngFor="let trendingItem of emptyListArray">
                      <ng-template carouselSlide>
                          <ipm-skeleton-loader></ipm-skeleton-loader>
                      </ng-template>
                    </ng-container>
                  </ng-template>
            </ng-container>
            <ng-container *ngIf="type === 'newFinds'">
                <ng-container *ngIf="newFindsData && newFindsData.length > 0; else newFindsLoadingSction">
                  <ng-container *ngFor="let findsBeatList of newFindsData">
                    <ng-template carouselSlide>
                        <ipm-beats [beatsList]="newFindsData" [dataType]="'object'" [beatObject]="findsBeatList"></ipm-beats>
                    </ng-template>
                </ng-container>
                </ng-container>
                <ng-template #newFindsLoadingSction>I
                  <ng-container *ngFor="let trendingItem of emptyListArray">
                      <ng-template carouselSlide>
                          <ipm-skeleton-loader></ipm-skeleton-loader>
                      </ng-template>
                    </ng-container>
                </ng-template>
            </ng-container>
            <ng-container *ngIf="type === 'ads_beats'">
              <ng-container *ngIf="adsBeatsData && adsBeatsData.length > 0; else adsLoadingSction">
                <ng-container *ngFor="let trendingItem of adsBeatsData">
                    <ng-template carouselSlide>
                        <ipm-beats [beatsList]="adsBeatsData" [dataType]="'object'" [beatObject]="trendingItem"></ipm-beats>
                    </ng-template>
                </ng-container>
              </ng-container>
                <ng-template #adsLoadingSction>
                  <ng-container *ngFor="let trendingItem of emptyListArray">
                    <ng-template carouselSlide>
                        <ipm-skeleton-loader></ipm-skeleton-loader>
                    </ng-template>
                </ng-container>
                </ng-template>
            </ng-container>
            <ng-container *ngIf="type === 'trending'">
              <ng-container *ngIf="trendingBeatsList && trendingBeatsList.length > 0; else trandingLoadingSction">
                    <ng-container *ngFor="let trendingItem of trendingBeatsList">
                    <ng-template carouselSlide>
                        <ipm-beats [beatsList]="trendingBeatsList" [dataType]="'object'" [beatObject]="trendingItem"></ipm-beats>
                    </ng-template>
                </ng-container>
              </ng-container>
                <ng-template #trandingLoadingSction>
                  <ng-container *ngFor="let trendingItem of emptyListArray">
                    <ng-template carouselSlide>
                        <ipm-skeleton-loader></ipm-skeleton-loader>
                    </ng-template>
                </ng-container>
                </ng-template>
            </ng-container>
            <ng-container *ngIf="type === 'bpmArena'">
              <ng-container *ngIf="bpmBeatsList && bpmBeatsList.length > 0; else bpmLoadingSction">
                    <ng-container *ngFor="let trendingItem of bpmBeatsList">
                    <ng-template carouselSlide>
                        <ipm-beats [beatsList]="bpmBeatsList" [dataType]="'object'" [beatObject]="trendingItem"></ipm-beats>
                    </ng-template>
                </ng-container>
              </ng-container>
                <ng-template #bpmLoadingSction>
                  <ng-container *ngFor="let trendingItem of emptyListArray">
                    <ng-template carouselSlide>
                        <ipm-skeleton-loader></ipm-skeleton-loader>
                    </ng-template>
                </ng-container>
                </ng-template>
            </ng-container>
        </owl-carousel-o>

    </div>
</div>

